/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyInfo,
    JsonEventPartyInfoFromJSON,
    JsonEventPartyInfoFromJSONTyped,
    JsonEventPartyInfoToJSON,
} from './JsonEventPartyInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventPartyInfo
 */
export interface ApiResultOfListOfJsonEventPartyInfo {
    /**
     * 
     * @type {Array<JsonEventPartyInfo>}
     * @memberof ApiResultOfListOfJsonEventPartyInfo
     */
    data?: Array<JsonEventPartyInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventPartyInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyInfo
     */
    result?: ApiResultOfListOfJsonEventPartyInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventPartyInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventPartyInfoFromJSON(json: any): ApiResultOfListOfJsonEventPartyInfo {
    return ApiResultOfListOfJsonEventPartyInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventPartyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventPartyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventPartyInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventPartyInfoToJSON(value?: ApiResultOfListOfJsonEventPartyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventPartyInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

